module.exports = __webpack_public_path__ + "img/more.77f9519c.svg";